import { BaseService } from './base.service.js';
class LibreOfficeService extends BaseService {
    async convert2pdf(source) {
        const res = await this.fetch(`/libre-office/convert2pdf?source=${encodeURIComponent(source)}`);
        return res.data;
    }
}
export const libreOfficeService = new LibreOfficeService();
